import { AssistChip, Skeleton, Stack, Text } from '@sixui/ui';

import { Table } from '~/components/molecules/Table';

export const LegalDocumentListItemSkeleton: React.FC = () => (
  <Table.Row>
    <Stack as={Table.Body} horizontal gap={3}>
      <Stack gap={1}>
        <Text
          as={Skeleton}
          variant="title"
          size="sm"
          length={{ min: 8, max: 24 }}
        />
      </Stack>
    </Stack>

    <Table.Body>
      <Skeleton length={3} />
    </Table.Body>

    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }}>
        <AssistChip />
      </Skeleton>
    </Table.Body>

    <Stack as={Table.Body} justify="end">
      <Skeleton length={8} />
    </Stack>
  </Table.Row>
);
